import type { UserManager } from "oidc-client-ts";
import { useCallback, useContext } from "react";
import { UserManagersContext } from "@/context/user-managers";

export function useSilentTokenRefresh() {
  const context = useContext(UserManagersContext);

  if (!context) {
    throw new Error("useSilentTokenRefresh must be used within UserManagersProvider");
  }

  const { setSilentRefreshInProgress } = context;

  const silentRefresh = useCallback(
    async (userManager?: UserManager) => {
      if (!userManager) {
        return;
      }

      try {
        // Set flag to indicate silent refresh is in progress
        setSilentRefreshInProgress?.(true);

        await userManager.signinSilent();
      } catch (error) {
        console.error("[DEBUG] Silent token refresh failed:", error);
        throw error;
      } finally {
        // Always clear the flag
        setSilentRefreshInProgress?.(false);
      }
    },
    [setSilentRefreshInProgress]
  );

  return silentRefresh;
}
